import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { countryRegex, marketplaceRegex, defaultMarketplace } from './constants';
/**
 * @param {string} cookieValue - e.g. 'cc=US,rc=WA,tp=vhigh,tz=PST,la=47.6115,lo=-122.3343,bw=5000'
 * @returns {object} containing key-value pairs from cookie
 */

export function parseCookie(cookieValue) {
  return cookieValue.split(',').reduce(function (acc, curr) {
    var _curr$split = curr.split('='),
        _curr$split2 = _slicedToArray(_curr$split, 2),
        key = _curr$split2[0],
        value = _curr$split2[1];

    acc[key] = value;
    return acc;
  }, {});
}
/**
 * Ensure code fed to function looks like a marketplace.
 *
 * @param {string} marketplaceCode - meant to be an ISO 3166-1 alpha-2 country code
 * @returns {string|undefined} uppercase two-letter code
 * @throws if input is invalid
 */

export function validateCode(marketplaceCode) {
  if (!marketplaceCode) {
    return marketplaceCode;
  } else if (countryRegex.exec(marketplaceCode)) {
    return marketplaceCode.toUpperCase();
  }

  throw new Error("cannot determine mismatch: \"".concat(marketplaceCode, "\" is not a recognized marketplace code"));
}
/**
 * Get the marketplace value from the url.
 *
 * @param {string} path - url path, as returned by window.location.pathname
 * @returns {string} uppercase marketplace code
 */

export function getMarketplaceFromURL(path) {
  var match = marketplaceRegex.exec(path);
  return match ? match[1].toUpperCase() : defaultMarketplace;
}